import { createFileRoute, redirect } from "@tanstack/react-router";

// The Discovery Set has been retired. Anyone landing here is redirected to
// the canonical Chapter Vials product page.
export const Route = createFileRoute("/discovery-set")({
  beforeLoad: () => {
    throw redirect({
      to: "/products/$slug",
      params: { slug: "chapter-vials" },
      statusCode: 301,
    });
  },
});
